
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Service } from '../../../../models/service.model';
import { AlertService } from '../../../../services/alert.service';


@Component({
    selector: 'create-edit-service-modal',
    template: require('./create-edit-service-modal.component.html'),
    styles: [require('./create-edit-service-modal.component.css')]
})
export class CreateEditServiceModalComponent {
    currentService: Service;
    isCreatNew: boolean;
    serviceTypes = [];
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditServiceModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentService.serviceId == undefined);
        this.currentService = data.currentService;

        this.apiService.getServiceTypes().subscribe(r => {
            this.serviceTypes = r;
        })
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateService(this.currentService).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Service successfully");
                }
            });
        } else {
            this.apiService.createService(this.currentService).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Service successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/services/create-edit-service-modal/create-edit-service-modal.component.ts